import { useNavigate } from 'react-router-dom';
import CustomBlockButton from '../../../../../components/button/CustomBlockButton';
import * as St from './weget-logout-button.styled';
import { signOut } from 'firebase/auth';
import firebaseAuth from '../../../../../firebase/auth';
import { UserAuthApi } from '@/apis/v2/UserAuthApi';
import { setMemoryAccessToken } from '@/storages/authStorage';
import { useUserContextActionsHook } from '@/contexts/UserContextProvider';
import { useAuthContextActionsHook } from '@/contexts/AuthContext';
import { useUserPageContextActionsHook } from '@/contexts/UserPageContextProvider';

const PAGE_CLIENT_URL = process.env.REACT_APP_PAGE_CLIENT_URL;

export function WegetLogoutButton(props) {
    const navigate = useNavigate();
    const authContextActionsHook = useAuthContextActionsHook();
    const userContextActionsHook = useUserContextActionsHook();
    const userPageContextActionsHook = useUserPageContextActionsHook();

    const handleSignOut = async (method) => {
        const signoutServerResult = await UserAuthApi.Signout({
            body: {
                payload: {
                    method: method || 'SINGLE'
                }
            }
        })

        if (signoutServerResult.data.data) {
            const signoutResult = await signOut(firebaseAuth);
            setMemoryAccessToken(null);
            userContextActionsHook.onClear();
            authContextActionsHook.logout();
            userPageContextActionsHook.onClear();
            // navigate({
            //     pathname: `${PAGE_CLIENT_URL}`
            // })
            window.location.href = `${PAGE_CLIENT_URL}`;
        }
    }

    return (
        <>
            <St.Container>
                <CustomBlockButton
                    type='button'
                    onClick={() => handleSignOut('SINGLE')}
                >
                    로그아웃
                </CustomBlockButton>
                <CustomBlockButton
                    type='button'
                    onClick={() => handleSignOut('ALL')}
                    className='multiple-logout'
                >
                    모든 기기에서 로그아웃
                </CustomBlockButton>
            </St.Container>
        </>
    );
}